(function () {
  // Infime try-on buttons on homepage + collection pages (product cards + quick add modal).
  //
  // The Infime SDK (tryon.js) scans the page once: it hides every [data-infime-tryon-id] element,
  // fetches descriptors for all ids, then shows the ones Infime knows and binds a click listener to each.
  // Cards added later (filtering, sorting, quick add modal) need another scan, but every scan binds
  // the click listener again on buttons it already bound, so one click would open the try-on twice.
  // Clicks are handled here in the capture phase instead, so the SDK's own listeners never run.
  const TRYON_SELECTOR = "[data-infime-tryon-id]";
  const PENDING_SELECTOR = TRYON_SELECTOR + ":not(.infime-visible)";
  let refreshTimer = null;

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target instanceof Element ? e.target.closest(TRYON_SELECTOR) : null;
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (!window.infimeTryon) return;

      // Same steps as the SDK's own click listener
      if (typeof window.infimeTryonRefreshEcomData === "function") {
        window.infimeTryonRefreshEcomData();
      }

      window.infimeTryon.open(
        btn.getAttribute("data-infime-tryon-id"),
        btn.getAttribute("data-infime-tryon-color"),
        btn.getAttribute("data-infime-tryon-ecom")
      );
    },
    true
  );

  function hasPendingButton(node) {
    return (
      node.nodeType === Node.ELEMENT_NODE &&
      (node.matches(PENDING_SELECTOR) || node.querySelector(PENDING_SELECTOR) !== null)
    );
  }

  // Re-scan when new buttons show up, so they get their descriptors and become visible
  new MutationObserver(function (mutations) {
    const added = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, hasPendingButton);
    });

    if (!added || typeof window.infimeTryonRefreshProducts !== "function") return;

    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(window.infimeTryonRefreshProducts, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
